var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIkon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22B473",
    fillRule: "evenodd",
    d: "M49.683 7.44c.42.427.423 1.128.007 1.558L18.669 40.983a1.053 1.053 0 0 1-1.515 0l-6.955-7.173-1.515-1.562-8.37-8.636a1.13 1.13 0 0 1 0-1.563l6.956-7.172a1.053 1.053 0 0 1 1.515 0l8.37 8.63c.42.432 1.102.432 1.516 0L41.161.324A1.06 1.06 0 0 1 42.68.318l7.003 7.123z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIkon);
export default __webpack_public_path__ + "static/media/success-ikon.edb228047d9a28a5a62114961c496b6a.svg";
export { ForwardRef as ReactComponent };